import { render, staticRenderFns } from "./CreatePosition.vue?vue&type=template&id=aa1b6d74"
import script from "./CreatePosition.vue?vue&type=script&lang=js"
export * from "./CreatePosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports